import React from 'react';

export const UFOIcon = () => {
	return (
		<svg width="300" height="161" viewBox="0 0 300 161" fill="none">
			<g clipPath="url(#clip0_11155_314919)">
				<path d="M76.5 137L81 61.5L112.5 35.5L276 137H76.5Z" fill="#EBEBEB" />
				<path
					d="M122.864 36.4903C122.959 36.8152 122.981 37.402 122.822 38.2776C122.667 39.1301 122.356 40.1695 121.878 41.3471C120.922 43.7007 119.328 46.5347 117.101 49.4213C112.645 55.1963 105.721 61.1005 96.4598 63.8174C87.1827 66.5389 77.2662 65.605 69.4829 63.4137C65.5957 62.3193 62.2752 60.9207 59.8647 59.5372C58.658 58.8447 57.7014 58.1685 57.0202 57.5524C56.3149 56.9145 56.0009 56.4268 55.914 56.1307C55.7762 55.6609 55.7553 54.9519 55.9342 53.9949C56.1105 53.0513 56.4681 51.9348 57.0132 50.6911C58.1029 48.2044 59.9077 45.2863 62.3611 42.3442C67.2702 36.4574 74.6943 30.5711 83.9729 27.8491C93.2541 25.1264 102.671 26.0319 109.975 28.3141C113.626 29.4547 116.718 30.9301 118.979 32.4401C120.11 33.1953 121.015 33.9475 121.676 34.6559C122.346 35.3731 122.719 35.9969 122.864 36.4903Z"
					fill="#D9D9D9"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M50.2819 46.732C50.2819 46.732 49.5716 48.4509 48.0797 49.9643C46.5877 51.4777 44.8791 52.2124 44.8791 52.2124C43.3563 50.7111 43.3313 48.2673 44.8232 46.754C46.3151 45.2406 48.7591 45.2308 50.2819 46.732Z"
					fill="#ffcc00"
				/>
				<path
					d="M120.388 26.4651C120.388 26.4651 121.915 27.5279 123.988 27.9955C126.061 28.463 127.895 28.1582 127.895 28.1582C128.366 26.0723 127.067 24.0022 124.994 23.5347C122.921 23.0671 120.859 24.3791 120.388 26.4651Z"
					fill="#ffcc00"
				/>
				<path
					d="M136.812 32.3013C136.739 32.3762 136.645 32.4664 136.529 32.5721C136.051 33.0043 135.294 33.5961 134.26 34.3198C132.198 35.7623 129.109 37.6763 125.13 39.8147C117.176 44.0904 105.707 49.2408 91.8596 53.3031C78.0112 57.3657 64.3908 59.5378 54.1955 60.5635C49.0981 61.0763 44.8681 61.3015 41.9045 61.3344C40.4191 61.351 39.2702 61.319 38.4962 61.2542C38.3012 61.2378 38.1384 61.2201 38.0055 61.2021C38.0075 60.8139 38.1042 60.282 38.3595 59.5884C38.7275 58.5889 39.3788 57.3782 40.3203 56.0048C42.2008 53.2617 45.165 49.9763 49.066 46.5841C56.8651 39.8022 68.3143 32.6756 82.0806 28.6371C95.8487 24.5981 109.323 24.3718 119.543 25.8462C124.655 26.5837 128.922 27.7422 131.987 29.0411C133.521 29.6913 134.724 30.3642 135.576 31.0157C136.22 31.5082 136.606 31.9449 136.812 32.3013Z"
					fill="#F4F4F4"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M138.183 32.2291C138.183 32.2291 126.033 42.8243 92.4162 54.1821C53.7451 64.6291 36.8491 62.1062 36.8491 62.1062"
					stroke="#A6A6A6"
					strokeWidth="4"
				/>
				<path
					d="M67.1055 41.2915C66.742 41.2769 66.4353 41.2602 66.191 41.2447C63.6798 31.4102 69.3478 21.3033 79.0912 18.445C88.8347 15.5866 99.0644 21.0298 102.264 30.6623C102.067 30.8073 101.818 30.9871 101.52 31.1957C100.672 31.7895 99.4291 32.616 97.8619 33.5383C94.724 35.3848 90.3027 37.6046 85.1549 39.1148C80.0071 40.6249 75.0874 41.1454 71.4492 41.2867C69.6321 41.3573 68.1399 41.3331 67.1055 41.2915Z"
					fill="#ffcc00"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<ellipse
					cx="52.1391"
					cy="49.3212"
					rx="1.94587"
					ry="3.73209"
					transform="rotate(44.4185 52.1391 49.3212)"
					fill="#ffcc00"
				/>
				<ellipse
					cx="67.7998"
					cy="50.5353"
					rx="2.66031"
					ry="3.73209"
					transform="rotate(30.0193 67.7998 50.5353)"
					fill="#ffcc00"
				/>
				<ellipse
					cx="1.94587"
					cy="3.73209"
					rx="1.94587"
					ry="3.73209"
					transform="matrix(-0.222949 0.97483 0.97483 0.222949 115.684 27.0105)"
					fill="#ffcc00"
				/>
				<ellipse
					cx="2.66031"
					cy="3.73209"
					rx="2.66031"
					ry="3.73209"
					transform="matrix(-0.458363 0.888765 0.888765 0.458363 104.271 35.1467)"
					fill="#ffcc00"
				/>
				<ellipse
					cx="87.5933"
					cy="46.3551"
					rx="4.30776"
					ry="3.46218"
					transform="rotate(-16.5297 87.5933 46.3551)"
					fill="#ffcc00"
				/>
				<path
					d="M78.7721 19.8899L79.0536 20.8495L80.9727 20.2865L80.6913 19.3269L78.7721 19.8899ZM80.6913 19.3269L76.7314 5.82864L74.8123 6.39164L78.7721 19.8899L80.6913 19.3269Z"
					fill="#A6A6A6"
				/>
				<circle
					cx="75.7726"
					cy="6.10994"
					r="1.87084"
					transform="rotate(-16.3496 75.7726 6.10994)"
					fill="#A6A6A6"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<ellipse cx="176" cy="136.5" rx="100" ry="12" fill="#D9D9D9" />
				<path
					d="M146.251 75.9921L189.038 96.1261C191.494 97.2822 193.391 99.3668 194.311 101.922C195.231 104.476 195.098 107.292 193.942 109.748L187.663 123.092C187.515 123.406 187.307 123.687 187.051 123.92C186.794 124.154 186.494 124.334 186.168 124.452C185.842 124.569 185.496 124.621 185.15 124.605C184.803 124.588 184.464 124.504 184.15 124.356L128.462 98.1513C128.148 98.0037 127.867 97.7957 127.633 97.5393C127.4 97.2829 127.22 96.9831 127.102 96.6569C126.985 96.3307 126.933 95.9846 126.949 95.6383C126.965 95.292 127.05 94.9524 127.197 94.6387L133.875 80.4477C134.926 78.2157 136.819 76.4923 139.14 75.6568C141.461 74.8212 144.019 74.9418 146.251 75.9921Z"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M146.209 90.5269L136.012 85.7283C135.55 85.5111 135.194 85.1195 135.021 84.6396C134.849 84.1596 134.874 83.6308 135.091 83.1692L135.684 81.9088C135.91 81.4274 136.243 81.0036 136.657 80.6694C137.071 80.3352 137.555 80.0994 138.074 79.9796C138.592 79.8598 139.131 79.8592 139.65 79.9779C140.168 80.0965 140.653 80.3314 141.068 80.6646L146.727 85.2066C147.138 85.5369 147.426 85.996 147.545 86.51C147.664 87.024 147.606 87.563 147.382 88.0402L146.209 90.5269Z"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M178.69 105.811L188.888 110.61C189.349 110.827 189.878 110.852 190.358 110.679C190.838 110.506 191.23 110.15 191.447 109.689L192.04 108.428C192.266 107.947 192.381 107.42 192.374 106.888C192.368 106.356 192.241 105.833 192.003 105.357C191.765 104.881 191.422 104.466 191 104.142C190.578 103.818 190.088 103.594 189.567 103.487L182.46 102.021C181.943 101.915 181.406 101.985 180.934 102.221C180.462 102.457 180.084 102.845 179.859 103.323L178.69 105.811Z"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M180.236 102.762L147.666 87.4352L146.211 90.5272L178.781 105.854L180.236 102.762Z"
					fill="#F4F4F4"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M163.086 96.8058C164.042 97.2553 165.18 96.8454 165.63 95.8902C166.079 94.9351 165.669 93.7965 164.714 93.347C163.759 92.8976 162.62 93.3075 162.171 94.2626C161.721 95.2177 162.131 96.3564 163.086 96.8058Z"
					fill="#F4F4F4"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M138.044 93.6879L181.454 114.115L180.879 115.336C180.441 116.268 179.65 116.988 178.681 117.336C177.712 117.685 176.645 117.635 175.713 117.196L139.329 100.075C138.397 99.6367 137.678 98.8461 137.329 97.8773C136.981 96.9085 137.031 95.8407 137.469 94.909L138.044 93.6879Z"
					fill="#F4F4F4"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M187.67 78.9547L161.264 66.529C158.684 65.3149 155.542 65.7465 152.905 67.677L145.183 75.4888L190.928 97.0149L192.112 86.1263C191.919 82.865 190.25 80.1688 187.67 78.9547Z"
					fill="#ffcc00"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M145.304 69.9857L143.113 68.9543C142.253 68.5497 141.228 68.9188 140.823 69.7786L140.752 69.9296C140.347 70.7895 140.716 71.8146 141.576 72.2192L143.768 73.2506C144.628 73.6552 145.653 73.2862 146.058 72.4263L146.129 72.2753C146.533 71.4155 146.164 70.3904 145.304 69.9857Z"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M197.282 94.4457L195.09 93.4143C194.231 93.0097 193.205 93.3787 192.801 94.2386L192.73 94.3895C192.325 95.2494 192.694 96.2745 193.554 96.6792L195.746 97.7105C196.606 98.1152 197.631 97.7461 198.035 96.8862L198.106 96.7353C198.511 95.8754 198.142 94.8503 197.282 94.4457Z"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M136.095 101.743L127.688 97.7864L125.614 102.194L134.021 106.15L136.095 101.743Z"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M184.302 124.427L175.895 120.471L173.821 124.879L182.228 128.835L184.302 124.427Z"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M187.672 78.9553L161.267 66.5296C160.231 66.0675 159.107 65.8372 157.974 65.8547C156.84 65.8723 155.724 66.1373 154.703 66.6312L191.779 84.0781C191.509 82.9766 191.002 81.9475 190.292 81.0626C189.583 80.1777 188.689 79.4585 187.672 78.9553Z"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_11155_314919">
					<rect width="300" height="160" fill="white" transform="translate(0 0.5)" />
				</clipPath>
			</defs>
		</svg>
	);
};
